import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import arrowIcon from "../../../assets/right-arrow.png";
import explorer from "../../../assets/landingFeatures/explorer.png";
import favicon from "../../../assets/landingFeatures/nujobsfav.png";

import useMembersStore from "../../../store/members.store";
import { Tooltip } from "antd";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
function EvaluationMarketPlace({
  sidebarOpen,
  setSidebarOpen,
  subscriptionIsActive,
}) {
  const [isHomeCollapsed, setIsHomeCollapsed] = useState(true);
  const [isQHRFlowCollapsed, setIsQHRFlowCollapsed] = useState(true);
  const [isNuJobsCollapsed, setIsNuJobsCollapsed] = useState(true);
  const [isCollapsedTeam, setIsCollapsedTeam] = useState(true);
  const [isCollapsedMy, setIsCollapsedMy] = useState(true);
  const [isCollapsedAllResume, setIsCollapsedAllResume] = useState(true);
  const [isCollapsedInterviews, setIsCollapsedInterviews] = useState(true);
  const [isCollapsedSourcing, setIsCollapsedSourcing] = useState(true);
  const [isCollapsedJD, setIsCollapsedJD] = useState(true);
  const [isCollapsedSelections, setIsCollapsedSelections] = useState(true);
  const [isCollapsedEvaluations, setIsCollapsedEvaluations] = useState(true);

  const handleToggleCollapseTeam = () => {
    setIsCollapsedTeam(!isCollapsedTeam);
  };
  const handleToggleCollapseMy = () => {
    setIsCollapsedMy(!isCollapsedMy);
  };
  const handleToggleCollapseAllResume = () => {
    setIsCollapsedAllResume(!isCollapsedAllResume);
  };
  const handleToggleCollapseInterviews = () => {
    setIsCollapsedInterviews(!isCollapsedInterviews);
  };
  const handleToggleCollapseSourcing = () => {
    setIsCollapsedSourcing(!isCollapsedSourcing);
  };
  const handleToggleCollapsejd = () => {
    setIsCollapsedJD(!isCollapsedJD);
  };

  const handleToggleCollapseSelections = () => {
    setIsCollapsedSelections(!isCollapsedSelections);
  };

  const handleToggleCollapseEvaluations = () => {
    setIsCollapsedEvaluations(!isCollapsedEvaluations);
  };
  return (
    <div>
      <button
        className={`img-toggle ${
          isHomeCollapsed ? "" : "active"
        }`}
        onClick={() => setIsHomeCollapsed(!isHomeCollapsed)}
        data-bs-toggle="collapse"
        data-bs-target="#home-collapse"
        aria-expanded={isCollapsedTeam ? "false" : "true"}
      >
        <img
          src={favicon}
          alt="Arrow"
          width="20"
          height="20"
          className={`arrow-icon me-2 `}
        />
        Eval MarketPlace
      </button>

      {!isHomeCollapsed && (
        <div style={{ marginLeft: "10px", marginTop: "10px" }}>
          <div>
            <hr className="sidebar-hr"></hr>
          </div>

          {/* <Link className="sidebar-link" to="/resume_source">
                Resume Sourcing
            </Link> */}
          <div style={{ marginBottom: "60px" }}>
            <button
              className={`btn btn-toggle d-inline-flex align-items-center border-0 ${
                isCollapsedSourcing ? "" : "active" // Add the active class conditionally
              } sideFont`}
              onClick={handleToggleCollapseSourcing}
              data-bs-toggle="collapse"
              data-bs-target="#home-collapse"
              aria-expanded={isCollapsedSourcing ? "false" : "true"}
            >
              <img
                src={arrowIcon}
                alt="Arrow"
                width="10"
                height="10"
                className={`arrow-icon me-2 ${
                  isCollapsedSourcing ? "" : "rotate"
                }`}
              />
              Evals
            </button>

            {!isCollapsedSourcing && (
              <ul id="home-collapse" className="">
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to="/globalEvaluations"
                    onClick={() => setSidebarOpen(false)}
                  >
                    All Evaluations
                  </Link>
                </li>

                {/* Add more list items as needed */}
              </ul>
            )}
          </div>
        </div>
      )}
      <hr className="sidebar-hr"></hr>
    </div>
  );
}

export default EvaluationMarketPlace;
